import type { ProjectInquiryPayload } from './projectInquirySchema';

export class ProjectInquiryError extends Error {
  constructor(message: string, public status?: number) {
    super(message);
  }
}

type ProjectInquiryResponse = { message?: string };

function parseResponse(value: unknown): ProjectInquiryResponse {
  if (typeof value !== 'object' || value === null || !('message' in value)) return {};
  return typeof value.message === 'string' ? { message: value.message } : {};
}

export async function submitProjectInquiry(payload: ProjectInquiryPayload, signal?: AbortSignal) {
  const endpoint = import.meta.env.VITE_SUBMIT_PROJECT_INQUIRY_URL;
  if (!endpoint) {
    throw new ProjectInquiryError('The online form is not connected yet. Please use the email fallback below.');
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  });

  let result: ProjectInquiryResponse = {};
  try {
    const parsed: unknown = await response.json();
    result = parseResponse(parsed);
  } catch {
    // The server may return an empty or non-JSON error response.
  }

  if (!response.ok) {
    throw new ProjectInquiryError(result.message || 'The request could not be sent. Please try again or use email.', response.status);
  }
  return result;
}
